import { useMutation } from '@tanstack/react-query';
import { createEmployee } from '../api/employee.api';
import { EmployeeFormData } from '../types/employee.types';

export const useCreateEmployee = () => {
  return useMutation({
    mutationFn: (data: EmployeeFormData) => createEmployee(data),
  });
};
